import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { CurrentRestaurantService } from '../services/current-restaurant.service';

// A lab that does not sell to the public has no floor, no till and no customer menu: typing the
// address must lead nowhere, exactly as the missing menu entry suggests.
export const publicSalesGuard: CanActivateFn = async () => {
  const currentRestaurant = inject(CurrentRestaurantService);
  const router = inject(Router);
  if (!currentRestaurant.current) {
    await currentRestaurant.load().catch(() => undefined);
  }
  return currentRestaurant.sellsToPublic ? true : router.parseUrl('/home');
};
